// @flow
import { Map }                                                                                                   from 'immutable';
import { Reducer }                                                                                               from '../../Reducer';
import { simpleOnItemCreateDone, simpleOnItemCreateFail, simpleOnItemCreateRequest, simpleOnItemCreateSuccess, } from '../../utils';
import * as TYPES                                                                                                from './types';

const DEFAULT_STATE = Map({
    item_created:     null,
    item_create_busy: false,
    error:            null,
});

export default class LocationsReducer extends Reducer {
    NAME = 'Locations';

    alias = {
        [ TYPES.LOCATION_CREATE_REQUEST ]: 'onItemCreateRequest',
        [ TYPES.LOCATION_CREATE_SUCCESS ]: 'onItemCreateSuccess',
        [ TYPES.LOCATION_CREATE_FAIL ]:    'onItemCreateFailure',
        [ TYPES.LOCATION_CREATE_DONE ]:    'onItemCreateDone',
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateRequest = simpleOnItemCreateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateSuccess = simpleOnItemCreateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateFailure = simpleOnItemCreateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateDone = simpleOnItemCreateDone(DEFAULT_STATE);

}
